// 吃瓜合集 演示数据 —— 全部为示例内容，仅用于页面展示

export interface HotItem {
  rank: number;
  title: string;
  category: string;
  heat: string;
  hot: number; // 0-100 热度占比
  trend: "up" | "down" | "new" | "flat";
  tag?: string;
  summary: string;
}

export interface CategoryCover {
  key: string;
  name: string;
  desc: string;
  count: number;
  color: string;
  image: string;
}

export interface HotPick {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  readCount: string;
  discussCount: string;
  time: string;
  image: string;
}

export const heroFeatured = {
  tag: "今日瓜王",
  title: "顶流演唱会门票“秒空”背后：黄牛、平台与粉丝的博弈",
  desc: "开售 12 秒即告售罄，二手平台却大量放票。这场围绕 3 万张门票的争夺，究竟卡在哪里？多位受访者还原抢票现场。",
  category: "娱乐八卦",
  heat: "3.2 亿阅读",
  discuss: "128 万讨论",
  trend: "up",
};

export const liveTicker: string[] = [
  "某主播带货翻车引发全网热议",
  "新一线城市深夜发布落户新政",
  "年度爆款剧大结局冲上热搜",
  "程序员吐槽大会播放量破亿",
  "网红餐厅排队 4 小时值不值",
  "知名车企宣布降价 5 万",
  "多地中小学引入课后延时服务",
];

export const rankingTabs = ["全站", "娱乐", "科技", "社会", "体育", "财经"];

export const rankingData: Record<string, HotItem[]> = {
  全站: [
    { rank: 1, title: "顶流演唱会门票秒空，黄牛加价 3 倍还抢不到", category: "娱乐", heat: "3.2亿", hot: 100, trend: "up", tag: "爆", summary: "开售12秒售罄，二手平台大量放票引质疑" },
    { rank: 2, title: "某头部主播直播间单场 GMV 破 50 亿刷新纪录", category: "财经", heat: "2.6亿", hot: 88, trend: "up", tag: "热", summary: "618 大促首日成绩单亮眼" },
    { rank: 3, title: "新一代国产手机发布，影像系统成最大卖点", category: "科技", heat: "1.9亿", hot: 76, trend: "new", tag: "新", summary: "全焦段主摄方案引发讨论" },
    { rank: 4, title: "新一线城市深夜发布人才落户新政", category: "社会", heat: "1.5亿", hot: 68, trend: "up", summary: "本科以上可直接落户" },
    { rank: 5, title: "年度爆款剧大结局上线，主创深夜发文", category: "娱乐", heat: "1.2亿", hot: 61, trend: "flat", tag: "热", summary: "开放式结局引爆二创" },
    { rank: 6, title: "国足世预赛关键战名单公布", category: "体育", heat: "9.8千万", hot: 54, trend: "down", summary: "多名新面孔入选集训" },
    { rank: 7, title: "奶茶品牌集体涨价，十元时代或成过去", category: "财经", heat: "8.6千万", hot: 48, trend: "up", summary: "原料成本推动终端调价" },
    { rank: 8, title: "程序员社区曝出开源项目停更风波", category: "科技", heat: "7.4千万", hot: 43, trend: "new", tag: "新", summary: "维护者发文回应质疑" },
    { rank: 9, title: "多地中小学试点课后延时服务", category: "社会", heat: "6.2千万", hot: 38, trend: "flat", summary: "家长评价两极分化" },
    { rank: 10, title: "马拉松名将宣布赛季后退役", category: "体育", heat: "5.1千万", hot: 33, trend: "down", summary: "十年职业生涯画上句号" },
  ],
  娱乐: [
    { rank: 1, title: "顶流演唱会门票秒空，黄牛加价 3 倍还抢不到", category: "娱乐", heat: "3.2亿", hot: 100, trend: "up", tag: "爆", summary: "开售12秒售罄，二手平台大量放票引质疑" },
    { rank: 2, title: "年度爆款剧大结局上线，主创深夜发文", category: "娱乐", heat: "1.2亿", hot: 78, trend: "flat", tag: "热", summary: "开放式结局引爆二创" },
    { rank: 3, title: "新晋小花恋情被拍，工作室火速回应", category: "娱乐", heat: "9.7千万", hot: 70, trend: "up", tag: "新", summary: "双方暂未正式回应" },
    { rank: 4, title: "老牌乐队重组巡演官宣，票价瞬间售罄", category: "娱乐", heat: "8.3千万", hot: 63, trend: "up", summary: "歌单由粉丝票选决定" },
    { rank: 5, title: "综艺《爆梗现场》口碑回暖成暑期黑马", category: "娱乐", heat: "6.9千万", hot: 55, trend: "up", summary: "赛制调整获好评" },
    { rank: 6, title: "某选秀爱豆塌房？网传录音引热议", category: "娱乐", heat: "5.4千万", hot: 48, trend: "down", tag: "爆", summary: "公司称将追究造谣责任" },
    { rank: 7, title: "黄金档剧集收视率连破新高", category: "娱乐", heat: "4.2千万", hot: 40, trend: "flat", summary: "现实题材引发共鸣" },
  ],
  科技: [
    { rank: 1, title: "新一代国产手机发布，影像系统成最大卖点", category: "科技", heat: "1.9亿", hot: 100, trend: "new", tag: "新", summary: "全焦段主摄方案引发讨论" },
    { rank: 2, title: "程序员社区曝出开源项目停更风波", category: "科技", heat: "7.4千万", hot: 72, trend: "new", summary: "维护者发文回应质疑" },
    { rank: 3, title: "AI 编程助手免费版开放，引爆开发者圈", category: "科技", heat: "6.1千万", hot: 64, trend: "up", tag: "热", summary: "号称可完成八成重复工作" },
    { rank: 4, title: "国产大模型参数规模再刷新纪录", category: "科技", heat: "5.3千万", hot: 57, trend: "flat", summary: "推理能力评测亮眼" },
    { rank: 5, title: "折叠屏出货量暴涨，厂商押注新形态", category: "科技", heat: "4.4千万", hot: 50, trend: "down", summary: "铰链成本大幅下降" },
    { rank: 6, title: "某网盘被曝下载限速引众怒", category: "科技", heat: "3.6千万", hot: 42, trend: "down", summary: "官方紧急回应限速策略" },
  ],
  社会: [
    { rank: 1, title: "新一线城市深夜发布人才落户新政", category: "社会", heat: "1.5亿", hot: 100, trend: "up", summary: "本科以上可直接落户" },
    { rank: 2, title: "多地中小学试点课后延时服务", category: "社会", heat: "6.2千万", hot: 70, trend: "flat", summary: "家长评价两极分化" },
    { rank: 3, title: "暴雨预警连发，多部门启动应急响应", category: "社会", heat: "5.5千万", hot: 63, trend: "up", tag: "热", summary: "市民出行需注意安全" },
    { rank: 4, title: "城市更新试点名单出炉，老旧小区改造提速", category: "社会", heat: "4.7千万", hot: 56, trend: "flat", summary: "涉及电梯加装与管网改造" },
    { rank: 5, title: "外卖平台调整配送费规则引争议", category: "社会", heat: "3.9千万", hot: 49, trend: "down", summary: "骑手与用户各执一词" },
    { rank: 6, title: "高考志愿填报进入白热化阶段", category: "社会", heat: "3.2千万", hot: 43, trend: "up", summary: "就业导向成填报主流" },
  ],
  体育: [
    { rank: 1, title: "国足世预赛关键战名单公布", category: "体育", heat: "9.8千万", hot: 100, trend: "down", summary: "多名新面孔入选集训" },
    { rank: 2, title: "马拉松名将宣布赛季后退役", category: "体育", heat: "5.1千万", hot: 70, trend: "down", summary: "十年职业生涯画上句号" },
    { rank: 3, title: "CBA 季后赛对决出炉，辽粤再相逢", category: "体育", heat: "4.6千万", hot: 64, trend: "up", tag: "热", summary: "宿敌之战一触即发" },
    { rank: 4, title: "游泳世锦赛中国选手再夺两金", category: "体育", heat: "4.0千万", hot: 57, trend: "up", summary: "年轻小将表现惊艳" },
    { rank: 5, title: "中超射手王加盟海外联赛", category: "体育", heat: "3.3千万", hot: 50, trend: "flat", summary: "转会费创队史纪录" },
  ],
  财经: [
    { rank: 1, title: "某头部主播直播间单场 GMV 破 50 亿刷新纪录", category: "财经", heat: "2.6亿", hot: 100, trend: "up", tag: "热", summary: "618 大促首日成绩单亮眼" },
    { rank: 2, title: "奶茶品牌集体涨价，十元时代或成过去", category: "财经", heat: "8.6千万", hot: 72, trend: "up", summary: "原料成本推动终端调价" },
    { rank: 3, title: "新能源车价格战再起，多品牌宣布官降", category: "财经", heat: "7.2千万", hot: 66, trend: "new", tag: "新", summary: "部分车型直降 5 万" },
    { rank: 4, title: "金价创新高，大妈们开始变卖金饰", category: "财经", heat: "6.0千万", hot: 58, trend: "up", summary: "回收价已超买入成本" },
    { rank: 5, title: "多地景区门票预约系统升级", category: "财经", heat: "5.1千万", hot: 51, trend: "flat", summary: "暑期出游热度升温" },
    { rank: 6, title: "低空经济政策落地，相关概念股大涨", category: "财经", heat: "4.3千万", hot: 45, trend: "up", summary: "多个城市开放试点航线" },
  ],
};

export const categoryCovers: CategoryCover[] = [
  { key: "ent", name: "娱乐八卦", desc: "明星动态、影视综艺，爆款瓜料第一现场", count: 128, color: "text-accent-700", image: "https://readdy.ai/api/search-image?query=glowing%20stage%20lights%20with%20cinematic%20backstage%20atmosphere%2C%20dramatic%20warm%20bokeh%20and%20spotlight%20beams%2C%20editorial%20magazine%20cover%20style%2C%20vibrant%20but%20soft%20focus%2C%20rich%20gradient%20background&width=800&height=600&seq=cat-ent-x1&orientation=landscape" },
  { key: "tech", name: "科技圈", desc: "新机发布、大模型进展，行业硬核动态", count: 96, color: "text-primary-700", image: "https://readdy.ai/api/search-image?query=futuristic%20tech%20components%20on%20soft%20warm%20backdrop%2C%20abstract%20circuit%20patterns%20glowing%20amber%2C%20modern%20minimal%20product%20photography%2C%20clean%20editorial%20style&width=800&height=600&seq=cat-tech-x1&orientation=landscape" },
  { key: "social", name: "社会热点", desc: "民生百态、城市议题，读懂身边的大事", count: 84, color: "text-secondary-700", image: "https://readdy.ai/api/search-image?query=busy%20city%20streets%20aerial%20view%20at%20golden%20hour%2C%20soft%20warm%20light%2C%20documentary%20photography%20style%2C%20layered%20urban%20life%20in%20motion&width=800&height=600&seq=cat-social-x1&orientation=landscape" },
  { key: "sport", name: "体坛快讯", desc: "赛事战报、球星动态，热血现场直击", count: 62, color: "text-primary-700", image: "https://readdy.ai/api/search-image?query=dynamic%20sports%20stadium%20at%20night%20with%20bright%20field%20lights%2C%20athlete%20silhouette%20in%20motion%2C%20warm%20orange%20floodlight%20tone%2C%20sports%20photography&width=800&height=600&seq=cat-sport-x1&orientation=landscape" },
  { key: "fin", name: "财经风云", desc: "市场波动、消费趋势，看懂钱的去向", count: 58, color: "text-accent-700", image: "https://readdy.ai/api/search-image?query=rising%20stock%20chart%20lines%20in%20warm%20amber%20light%2C%20abstract%20finance%20visual%2C%20modern%20minimal%20background%2C%20soft%20gradient%2C%20business%20editorial%20photography&width=800&height=600&seq=cat-fin-x1&orientation=landscape" },
  { key: "life", name: "生活见闻", desc: "吃喝玩乐、城市新鲜事，人间烟火最动人", count: 74, color: "text-secondary-700", image: "https://readdy.ai/api/search-image?query=cozy%20street%20food%20stalls%20and%20warm%20lanterns%20at%20dusk%2C%20documentary%20lifestyle%20photography%2C%20people%20enjoying%20food%2C%20soft%20golden%20ambient%20light&width=800&height=600&seq=cat-life-x1&orientation=landscape" },
];

export const hotPicks: HotPick[] = [
  {
    id: "hp1",
    title: "三天连上两次热搜，这届年轻人为什么还在排队打卡",
    excerpt: "从网红餐厅到文创市集，线下消费正以一种新方式回归。我们观察了 5 个周末的现场，找到了排队背后的真实心理。",
    category: "社会热点",
    readCount: "286 万",
    discussCount: "1.4 万",
    time: "2 小时前",
    image: "https://readdy.ai/api/search-image?query=long%20queue%20outside%20a%20trendy%20store%20on%20a%20sunny%20weekend%2C%20young%20people%20chatting%20and%20holding%20phones%2C%20documentary%20editorial%20photo%2C%20warm%20natural%20light%2C%20lively%20street%20atmosphere&width=800&height=560&seq=hp-lineup-x1&orientation=landscape" },
  {
    id: "hp2",
    title: "一部剧带火一座城，取景地旅游订单暴涨 7 倍",
    excerpt: "爆款剧《山海一夜》播出后，拍摄地迅速出圈。当地文旅部门连夜推出同款路线，火车站都排起了打卡长队。",
    category: "娱乐八卦",
    readCount: "198 万",
    discussCount: "9.8 千",
    time: "5 小时前",
    image: "https://readdy.ai/api/search-image?query=ancient%20chinese%20town%20by%20the%20river%20at%20dusk%2C%20red%20lanterns%20reflected%20on%20water%2C%20tourists%20with%20phone%20taking%20photos%2C%20warm%20golden%20scene%2C%20editorial%20travel%20photography&width=800&height=560&seq=hp-drama-x1&orientation=landscape" },
  {
    id: "hp3",
    title: "国产 AI 一周三连更，卷不动了还是停不下来",
    excerpt: "开源社区持续沸腾：新模型、新定价、新应用密集落地。从业者感叹迭代太快，用户却乐见其成。",
    category: "科技圈",
    readCount: "154 万",
    discussCount: "8.2 千",
    time: "8 小时前",
    image: "https://readdy.ai/api/search-image?query=abstract%20neural%20network%20visual%20glowing%20in%20warm%20orange%20and%20amber%20tone%2C%20futuristic%20data%20streams%2C%20minimal%20tech%20background%2C%20clean%20modern%20design&width=800&height=560&seq=hp-ai-x1&orientation=landscape" },
  {
    id: "hp4",
    title: "金价一路走高，现在到底是卖金饰还是买金条？",
    excerpt: "连创新高的金价搅动无数家庭的资产表。几位过来人分享了他们的卖出与加仓经历，供你参考。",
    category: "财经风云",
    readCount: "121 万",
    discussCount: "6.3 千",
    time: "11 小时前",
    image: "https://readdy.ai/api/search-image?query=glittering%20gold%20bars%20and%20coins%20on%20dark%20velvet%2C%20macro%20photography%2C%20warm%20amber%20lighting%2C%20luxury%20finance%20editorial%20image&width=800&height=560&seq=hp-gold-x1&orientation=landscape" },
  {
    id: "hp5",
    title: "深夜的城市街头，外卖骑手在等什么",
    excerpt: "当写字楼灯光渐次熄灭，另一群人的工作才刚刚开始。我们跟拍了一位骑手的午夜，记录配送高峰的真实模样。",
    category: "生活见闻",
    readCount: "98 万",
    discussCount: "5.1 千",
    time: "16 小时前",
    image: "https://readdy.ai/api/search-image?query=delivery%20rider%20on%20scooter%20waiting%20under%20city%20night%20lights%2C%20moody%20cinematic%20street%20scene%2C%20warm%20streetlamp%20glow%2C%20documentary%20photography&width=800&height=560&seq=hp-rider-x1&orientation=landscape" },
  {
    id: "hp6",
    title: "跑步为什么成了中产的“新社交”？",
    excerpt: "从马拉松到城市夜跑，越来越多人在晨光与暮色中结伴出发。这股跑步热潮背后的心态变化，值得细品。",
    category: "体坛快讯",
    readCount: "86 万",
    discussCount: "4.4 千",
    time: "昨天",
    image: "https://readdy.ai/api/search-image?query=group%20of%20runners%20jogging%20through%20city%20park%20at%20dawn%2C%20warm%20morning%20sunlight%20through%20trees%2C%20sports%20documentary%20photography%2C%20dynamic%20motion&width=800&height=560&seq=hp-run-x1&orientation=landscape" },
];

export const faqs = [
  {
    q: "吃瓜合集的热度排名是怎么来的？",
    a: "我们的热度综合参考全网多个主流平台的讨论量、点击量、分享数与持续讨论趋势加权计算，并按一定时间窗口动态更新。榜单代表某一时段的公开讨论热度，不代表事实判断或立场。",
  },
  {
    q: "榜单多久更新一次？为什么排名会变化？",
    a: "实时热搜区一般数分钟刷新一次，综合榜单通常每小时更新。当某个话题讨论量集中爆发或快速回落时，排名就会相应变化，这也是“风口浪尖”肉眼可见的原因。",
  },
  {
    q: "我看到的内容可信吗？会不会是谣言？",
    a: "吃瓜合集聚合的是各平台正在被讨论的信息，意在帮大家快速了解“大家在聊什么”。我们不会为任何瓜料下结论，遇到未经核实的信息会标注来源或提醒。建议以官方通报为准。",
  },
  {
    q: "为什么有些瓜看着很“离谱”？",
    a: "互联网讨论本就众声喧哗，越是戏剧化的话题越容易被快速放大。我们保留这类高讨论度内容，是希望还原真实的话题热度，同时你可以在每篇内容里看到不同视角的评论。",
  },
  {
    q: "我可以在这里发布或投稿自己的话题吗？",
    a: "目前支持在评论中参与讨论。若你有靠谱、有公开来源的线索希望收录进榜单，可通过页脚的联系方式发给我们，核实后会纳入选题池。",
  },
  {
    q: "吃瓜合集会收费吗？",
    a: "浏览榜单与大部分内容是免费的。我们未来可能上线会员增值服务（如趋势数据导出、个性化订阅），但基础吃瓜功能永久免费。",
  },
];

export const hotStats = [
  { label: "今日收录话题", value: "1263", icon: "ri-flashlight-line" },
  { label: "全网讨论量", value: "8.4亿", icon: "ri-discuss-line" },
  { label: "实时在榜瓜料", value: "58", icon: "ri-fire-line" },
  { label: "用户参与评论", value: "132万", icon: "ri-chat-1-line" },
];